export default __webpack_public_path__ + "static/media/gol.974ef4a3.svg";